
import React from 'react';
import { FileText, Edit3 } from 'lucide-react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  rightElement?: React.ReactNode;
}

export const Input: React.FC<InputProps> = ({ label, className, rightElement, ...props }) => {
  return (
    <div className="flex flex-col gap-1 mb-4">
      <label className="text-[10px] font-bold text-raizama-textMain uppercase tracking-widest ml-1">{label}</label>
      <div className="relative w-full">
        <input
          className={`w-full bg-raizama-surface border border-raizama-border/30 rounded-lg p-3 text-raizama-textSec focus:outline-none focus:border-raizama-action transition-colors ${rightElement ? 'pr-12' : ''} ${className}`}
          {...props}
        />
        {rightElement && (
          <div className="absolute right-2 top-1/2 -translate-y-1/2">
            {rightElement}
          </div>
        )}
      </div>
    </div>
  );
};

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
}

export const TextArea: React.FC<TextAreaProps> = ({ label, className, ...props }) => {
  return (
    <div className="flex flex-col gap-2 mb-4 group">
      <label className="text-[10px] font-bold text-raizama-textMain uppercase tracking-widest flex items-center gap-2 ml-1 group-focus-within:text-raizama-highlight transition-colors">
        <FileText size={12} /> {label}
      </label>
      <div className="relative">
        <textarea
          className={`w-full bg-raizama-surface/40 border border-raizama-border/20 rounded-xl p-4 text-sm text-raizama-textSec focus:outline-none focus:border-raizama-action focus:ring-1 focus:ring-raizama-action/20 transition-all min-h-[140px] resize-none leading-relaxed placeholder:text-raizama-textSec/30 shadow-inner ${className}`}
          {...props}
        />
        <div className="absolute bottom-3 right-3 opacity-10 group-focus-within:opacity-40 transition-opacity pointer-events-none">
          <Edit3 size={16} className="text-raizama-action" />
        </div>
      </div>
    </div>
  );
};

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: { label: string; value: string }[];
}

export const Select: React.FC<SelectProps> = ({ label, options, className, ...props }) => {
  return (
    <div className="flex flex-col gap-1 mb-4">
      <label className="text-[10px] font-bold text-raizama-textMain uppercase tracking-widest ml-1">{label}</label>
      <select
        className={`w-full bg-raizama-surface border border-raizama-border/30 rounded-lg p-3 text-raizama-textSec focus:outline-none focus:border-raizama-action transition-colors appearance-none ${className}`}
        {...props}
      >
        <option value="" disabled>Selecione...</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </div>
  );
};
